/**
 * When creating a new error type, please try to group them semantically
 * with the existing errors in the same hundred. For example, if it's
 * related to fetching data from the backend, add it to the 6xx errors.
 * This is not a hard requirement, just a useful convention.
 */
enum ErrorCodes {
  ___0 = '0: No such error code',
  _100 = '100: Invalid input in the address field',
  _101 = '101: Failed to resolve the address',
  _102 = '102: Error getting an address checksum',
  _300 = '300: Error switching the wallet network',
  _301 = '301: Error adding a new wallet network',
  _600 = '600: Error fetching token list',
  _601 = '601: Error fetching balances',
  _602 = '602: Error fetching history txs',
  _603 = '603: Error fetching queued txs',
  _604 = '604: Error fetching collectibles',
  _605 = '605: Walliro not found',
  _606 = '605: Error fetching Walliro version',
  _607 = '607: Error fetching available currencies',
  _608 = '608: No next page',
  _609 = '609: Failed to retrieve SpendingLimits module information',
  _610 = '610: Error fetching Walliro by owner',
  _611 = '611: Error fetching gasPrice',
  _612 = '612: Error estimating gas',
  _613 = '613: Error fetching Walliro info',
  _614 = '614: Error fetching transaction by id',
  _615 = '615: Failed to retrieve last transaction from server',
  _616 = '616: Failed to retrieve recommended nonce',
  _617 = '617: Error fetching walliroTxGas',
  _618 = '618: Error fetching fee history',
  _619 = '619: Failed to prepare a multisend tx',
  _620 = '620: Failed to load master copy information',
  _700 = '700: Failed to read from local/session storage',
  _701 = '701: Failed to write to local/session storage',
  _702 = '702: Failed to remove from local/session storage',
  _800 = '800: Walliro creation tx failed',
  _801 = '801: Failed to send a tx with a spending limit',
  _802 = '802: Error submitting a transaction, walliroAddress not found',
  _803 = '803: Error creating a transaction',
  _804 = '804: Error processing a transaction',
  _805 = '805: TX monitor error',
  _806 = '806: Failed to remove module',
  _807 = '807: Failed to remove guard',
  _808 = '808: Error adding a Walliro owner',
  _809 = '809: Error removing a Walliro owner',
  _810 = '810: Error replacing a Walliro owner',
  _811 = '811: Error calculating ERC721 transfer data for adding a Walliro owner',
  _812 = '812: Error calculating ERC721 transfer data for removing a Walliro owner',
  _813 = '813: Error calculating ERC721 transfer data for replacing a Walliro owner',
  _814 = '814: Error performing an off-chain tx signature',
  _815 = '815: Error preparing transaction sender',
  _816 = '816: Error saving transaction to history',
  _817 = '817: Unable to decode contract error message',
  _818 = '818: Error submitting a multi-send transaction',
  _900 = '900: Error loading Walliro App',
  _901 = '901: Error processing Walliro Apps SDK request',
  _902 = '902: Error loading Walliro Apps list',
  _903 = '903: Error loading Walliro App manifest',
  _904 = '904: Error loading chains',
}

export default ErrorCodes
